<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeAttendanceReason
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeAttendanceReasonProps } from './interfaces'

import { AppBadge } from '@shared/ui/badges'

import { useBadgeAttendanceReason } from './use-badge-attendance-reason.hook'

defineOptions({
  name: 'BadgeAttendanceReason',
})

const props = defineProps<BadgeAttendanceReasonProps>()

const {
  color,
  text,
} = useBadgeAttendanceReason({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
